// extracted by mini-css-extract-plugin
export default {"link":"_1z0im2c","box-link":"_90qghi","boxLink":"_90qghi"};